import React, { useReducer, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment-timezone";
import { withStyles, Select, IconButton, MenuItem, Tooltip } from "@material-ui/core";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ActionCreators from './../../store/actions/index';
import { CALENDAR_TYPES } from "../../store/helpers/constantVariables";

const useStyles = theme => ({
    container: {
        display: "flex",
        alignItems: "center"
    },
    select: {
        width: 150
    }
});

const initialState = {
    nextPeriod: () => { },
    prevPeriod: () => { },
    reset: () => { }
}

function reducer(state, action) {
    switch (action.type) {
        case CALENDAR_TYPES.WEEK:
            return {
                nextPeriod: action.nextPeriod,
                prevPeriod: action.prevPeriod,
                reset: action.reset
            }
        case CALENDAR_TYPES.MONTH:
            return {
                nextPeriod: action.nextPeriod,
                prevPeriod: action.prevPeriod,
                reset: action.reset
            }
        case CALENDAR_TYPES.PERIOD:
            return {
                nextPeriod: action.nextPeriod,
                prevPeriod: action.prevPeriod,
                reset: action.reset
            }
        case CALENDAR_TYPES.QUARTER:
            return {
                nextPeriod: action.nextPeriod,
                prevPeriod: action.prevPeriod,
                reset: action.reset
            }
        default:
            return state;
    }
}

const PeriodSelection = props => {
    const { classes, calendarType, weekStartDate, weekEndDate, monthStartDate, monthEndDate } = props;
    const [state, innerDispatch] = useReducer(reducer, initialState);
    const [disable, setDisable] = useState(false);

    useEffect(() => {
        switch (calendarType) {
            case CALENDAR_TYPES.WEEK:
                setDisable(false);
                return innerDispatch({
                    type: CALENDAR_TYPES.WEEK,
                    nextPeriod: () => props.setWeekDataHandle({
                        weekStartDate: weekStartDate.add(7, "days"),
                        weekEndDate: weekEndDate.add(7, "days")
                    }),
                    prevPeriod: () => props.setWeekDataHandle({
                        weekStartDate: weekStartDate.subtract(7, "days"),
                        weekEndDate: weekEndDate.subtract(7, "days")
                    }),
                    reset: () => props.setWeekDataHandle({
                        weekStartDate: moment()
                            .startOf("day")
                            .subtract(1, "days"),
                        weekEndDate: moment().add(7, "days"),
                        weekDaysCount: 7
                    })
                });
            case CALENDAR_TYPES.MONTH:
                setDisable(false);
                return innerDispatch({
                    type: CALENDAR_TYPES.MONTH,
                    nextPeriod: () => props.setMonthDataHandle({
                        monthStartDate: monthStartDate.add(1, "month"),
                        monthEndDate: monthEndDate.add(1, "month"),
                        monthDaysCount: monthStartDate.daysInMonth()
                    }),
                    prevPeriod: () => props.setMonthDataHandle({
                        monthStartDate: monthStartDate.subtract(1, "month"),
                        monthEndDate: monthEndDate.subtract(1, "month"),
                        monthDaysCount: monthStartDate.daysInMonth()
                    }),
                    reset: () => props.setMonthDataHandle({
                        monthStartDate: moment().subtract(4, "days"),
                        monthEndDate: moment().add(27, "days"),
                        monthDaysCount: 31
                    })
                });
            case CALENDAR_TYPES.QUARTER:
                setDisable(true);
                return innerDispatch({
                    type: CALENDAR_TYPES.QUARTER,
                    nextPeriod: () => { },
                    prevPeriod: () => { },
                    reset: () => props.setQuarterDataHandle({
                        quarterStartDate: moment().startOf("month"),
                        quarterEndDate: moment()
                            .startOf("month")
                            .add(90, "days"),
                        quarterDaysCount: 90
                    })
                });
            case CALENDAR_TYPES.PERIOD:
                return setDisable(true);
            default:
                return setDisable(false);
        }
    }, [calendarType]);

    useEffect(() => {
        state.reset();
    }, [state.reset])

    return (
        <div className={classes.container}>
            <Tooltip
                placement="top"
                title="Poprzedni okres"
                arrow={true}
            >
                <IconButton
                    onClick={state.prevPeriod}
                    disabled={disable}
                >
                    <ArrowLeftIcon />
                </IconButton>
            </Tooltip>
            <Select
                className={classes.select}
                variant="outlined"
                value={calendarType}
                onChange={(e) => props.onSetCalendarType(e.target.value)}
            >
                <MenuItem value={CALENDAR_TYPES.WEEK}>Tydzień</MenuItem>
                <MenuItem value={CALENDAR_TYPES.MONTH}>Miesiąc</MenuItem>
                <MenuItem value={CALENDAR_TYPES.QUARTER}>Kwartał</MenuItem>
                <MenuItem value={CALENDAR_TYPES.PERIOD}>Okres</MenuItem>
            </Select>
            <Tooltip
                placement="top"
                title="Następny okres"
                arrow={true}
            >
                <IconButton
                    onClick={state.nextPeriod}
                    disabled={disable}
                >
                    <ArrowRightIcon />
                </IconButton>
            </Tooltip>
        </div>
    )
}

PeriodSelection.propTypes = {
    //redux
    calendarType: PropTypes.number,
    weekStartDate: PropTypes.object,
    weekEndDate: PropTypes.object,
    weekDaysCount: PropTypes.number,
    monthStartDate: PropTypes.object,
    monthEndDate: PropTypes.object,
    monthDaysCount: PropTypes.number,
    onSetCalendarType: PropTypes.func,
    setWeekDataHandle: PropTypes.func,
    setMonthDataHandle: PropTypes.func,
    setQuarterDataHandle: PropTypes.func
}

const mapStateToProps = (state) => ({
    calendarType: state.formReducer.calendarType,
    weekStartDate: state.formReducer.weekStartDate,
    weekEndDate: state.formReducer.weekEndDate,
    weekDaysCount: state.formReducer.weekDaysCount,
    monthStartDate: state.formReducer.monthStartDate,
    monthEndDate: state.formReducer.monthEndDate,
    monthDaysCount: state.formReducer.monthDaysCount,
})

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators(ActionCreators, dispatch),
        onSetCalendarType: value =>
            dispatch({ type: "SET_CALENDAR_TYPE", calendarType: value }),
        setWeekDataHandle: value =>
            dispatch({ type: "SET_WEEK_DATA", value: value }),
        setMonthDataHandle: value =>
            dispatch({ type: "SET_MONTH_DATA", value: value }),
        setQuarterDataHandle: value =>
            dispatch({ type: "SET_QUARTER_DATA", value: value }),
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(useStyles)(PeriodSelection))
